// extracted by mini-css-extract-plugin
module.exports = {"hosts":"footer_hosts__pLwe0","partnerLogo":"footer_partnerLogo__BD27c","container":"footer_container__LQ159","section":"footer_section__uRxuV","footer":"footer_footer__QNg0_"};